import type { StreamInfo } from "./state";

/**
 * Konkord: a stream's info is sent again at least this often when nothing
 * changed for real (it went every 3 s: each send re-renders the call of
 * everyone in it)
 */
export const STREAM_INFO_IDLE_MS = 15_000;

/** Konkord: these change for real, sent right away */
const EXACT: (keyof StreamInfo)[] = [
  "width",
  "height",
  "limit",
  "quality",
  "capture",
  "direct",
  "hardware",
  "server",
  "targetFps",
];

/** Konkord: these drift all the time, sent when they moved more than 10% */
const NUMBERS: (keyof StreamInfo)[] = [
  "fps",
  "bitrate",
  "captureFps",
  "upload",
];

/**
 * Konkord: whether a stream's info is worth sending now
 * @param previous What was sent last (undefined: nothing yet)
 * @param next What it is now
 * @returns Something changed for real, or a number moved over 10%
 */
export function streamInfoChanged(
  previous: StreamInfo | undefined,
  next: StreamInfo,
) {
  if (!previous) return true;
  if (EXACT.some((key) => previous[key] !== next[key])) return true;
  const moved = (key: keyof StreamInfo) => {
    const a = Number(previous[key] ?? 0);
    const b = Number(next[key] ?? 0);
    return Math.abs(a - b) > Math.max(1, Math.abs(a) * 0.1);
  };
  return (
    NUMBERS.some(moved) || Math.abs((previous.loss ?? 0) - next.loss) > 0.01
  );
}
